"use client"

import { useQuery } from "@tanstack/react-query"
import {
  listAgentPromptVersionsAction,
  type AgentPromptScopeType,
  type AgentPromptVersionView,
} from "@/server-actions/agent-prompt-versions"

export type { AgentPromptScopeType, AgentPromptVersionView }

export const AGENT_PROMPT_VERSIONS_QUERY_KEY = ["agent-prompt-versions"] as const

export const agentPromptVersionsQueryKey = (
  scopeType: AgentPromptScopeType,
  scopeId: string,
  useCase: string,
) => [...AGENT_PROMPT_VERSIONS_QUERY_KEY, scopeType, scopeId, useCase] as const

export function useAgentPromptVersionsQuery(
  scopeType: AgentPromptScopeType,
  scopeId: string,
  useCase: string,
  enabled: boolean,
) {
  return useQuery<AgentPromptVersionView[]>({
    queryKey: agentPromptVersionsQueryKey(scopeType, scopeId, useCase),
    enabled: enabled && Boolean(scopeId),
    // The prompt is saved outside React Query, so the global 60s staleTime would show a
    // list missing the version just recorded — the one moment users open this dialog.
    staleTime: 0,
    refetchOnMount: "always",
    queryFn: async () => {
      const result = await listAgentPromptVersionsAction({
        scope_type: scopeType,
        scope_id: scopeId,
        use_case: useCase,
      })
      if ("status" in result) throw new Error(result.errorMessage)
      return result
    },
  })
}
